import React from "react";

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = "",
}) => {
  return (
    <nav className={`mb-4 ${className}`} aria-label="パンくずナビゲーション">
      <ol className="flex flex-wrap items-center gap-y-1 text-xs text-primary-600">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <span className="mx-2 text-primary-400" aria-hidden="true">
                &gt;
              </span>
            )}
            {item.href ? (
              <a
                href={item.href}
                className="underline text-primary-600 hover:text-primary-700 active:text-secondary-500 transition-colors duration-200"
              >
                {item.label}
              </a>
            ) : (
              <span
                className="text-primary-600 font-medium"
                aria-current={index === items.length - 1 ? "page" : undefined}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
